module.exports = __webpack_public_path__ + "img/ded-stock-2.4287ce08.png";